module.exports = __webpack_public_path__ + "img/construction.c1e4f3d8.png";